import React from "react";
import "../style/contacto.css";

const Contacto = () => {
  return (
    <div id="contacto" className="contact-container">
      <div>
        <h1 className="headings">Contacto</h1>
        <p style={{textAlign: 'center'}}>Si quieres contactarme, puedes encontrarme en:</p>
      </div>
      <div className="social">
        <a href="mailto:khanchandani58@gmail.com" target="blank">
          <i className="fas fa-envelope"></i>
        </a>
        <a href="https://github.com/khanchandanivikas" target="blank">
          <i className="fab fa-github"></i>
        </a>
        <a
          href="https://www.linkedin.com/in/vikas-khanchandani-28414b138"
          target="blank"
        >
          <i className="fab fa-linkedin-in"></i>
        </a>
        <a href="https://www.instagram.com/vikas_khh/" target="blank">
          <i className="fab fa-instagram"></i>
        </a>
      </div>
    </div>
  );
};

export default Contacto;
